import { useEffect, useState } from 'react';

/** דסקטופ = ≥ 768px (כמו md: של Tailwind) — לרכיבים שמצוירים רק באחד המצבים (בלי testid כפול ב-DOM). */
export function useIsDesktop() {
  const q = '(min-width: 768px)';
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return m;
}
